"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _constants = require("../../constants");

var _Button = _interopRequireDefault(require("../Button"));

var _Column = _interopRequireDefault(require("../Column"));

var _Header = _interopRequireDefault(require("../Header"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Input = _interopRequireDefault(require("../Input"));

var _Label = _interopRequireDefault(require("../Label"));

var _List = _interopRequireDefault(require("../List"));

var _Row = _interopRequireDefault(require("../Row"));

var _MediaSize = _interopRequireDefault(require("../MediaSize"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Pagination =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Pagination, _PureComponent);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getCenterRange", function () {
      var centerRange = _this.props.centerRange; // centerRange is odd number

      if (centerRange % 2 === 1) return centerRange; // otherwise return default 5

      return Pagination.defaultCenterRange;
    });

    _defineProperty(_assertThisInitialized(_this), "handleMediaSizeOnChange", function (e, _ref) {
      var isMobile = _ref.isMobile;

      if (isMobile) {
        // force centerRange to 5 for mobile view
        _this.setState({
          centerRange: Pagination.defaultCenterRange
        });
      } else {
        _this.setState({
          centerRange: _this.getCenterRange()
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddInputListener", function () {
      var inputNode = _this.inputRef.current;

      if (inputNode) {
        inputNode.addEventListener('keyup', _this.handlePressEnterCheck, false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemoveInputListener", function () {
      var inputNode = _this.inputRef.current;

      if (inputNode) {
        inputNode.removeEventListener('keyup', _this.handlePressEnterCheck, false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePressEnterCheck", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault');

      if (e.keyCode === _constants.KEY_ENTER) {
        // enter pressed
        _this.handleConfirmNavigate();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calcPagination", function () {
      var totalPages = _this.state.totalPages;
      var pagination = [];

      for (var i = 0; i < totalPages; i += 1) {
        var number = i + 1;
        pagination.push(number);
      }

      return pagination;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnPageClick", function (e, number) {
      var _this$props = _this.props,
          name = _this$props.name,
          disabled = _this$props.disabled;
      var current = _this.state.current;
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (number && current !== number) {
        _this.setState({
          current: number
        }, function () {
          var _this$props2 = _this.props,
              onChange = _this$props2.onChange,
              size = _this$props2.size;
          var from = Pagination.calcOffset(size, number);

          if (onChange) {
            onChange(e, {
              name: name,
              value: from
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [Pagination.className]; // IE flexbox fixes

      if ((0, _lib.isIE)()) names.push('IE');
      var propNames = ['fluid'];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBack", function (e) {
      var _this$props3 = _this.props,
          name = _this$props3.name,
          disabled = _this$props3.disabled;
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var current = _this.state.current;
      var currentIndex = current - 1;

      if (currentIndex > 0) {
        _this.setState(function (prevState) {
          return {
            current: prevState.current - 1
          };
        }, function () {
          var _this$props4 = _this.props,
              onChange = _this$props4.onChange,
              onBack = _this$props4.onBack,
              size = _this$props4.size;
          current = _this.state.current;
          var from = Pagination.calcOffset(size, current);

          if (onChange) {
            onChange(e, {
              name: name,
              value: from
            });
            if (onBack) onBack();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleToFirst", function (e) {
      var _this$props5 = _this.props,
          name = _this$props5.name,
          disabled = _this$props5.disabled;
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var current = _this.state.current;
      var currentIndex = current - 1;

      if (currentIndex > 0) {
        _this.setState({
          current: 1
        }, function () {
          var _this$props6 = _this.props,
              onChange = _this$props6.onChange,
              onBack = _this$props6.onBack,
              size = _this$props6.size;
          var from = Pagination.calcOffset(size, 1);

          if (onChange) {
            onChange(e, {
              name: name,
              value: from
            });
            if (onBack) onBack();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnNext", function (e) {
      var _this$props7 = _this.props,
          name = _this$props7.name,
          disabled = _this$props7.disabled;
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var totalPages = _this.state.totalPages;
      var current = _this.state.current;
      var currentIndex = current - 1; // index length = total pages

      if (currentIndex < totalPages - 1) {
        _this.setState(function (prevState) {
          return {
            current: prevState.current + 1
          };
        }, function () {
          var _this$props8 = _this.props,
              onChange = _this$props8.onChange,
              onNext = _this$props8.onNext,
              size = _this$props8.size;
          current = _this.state.current;
          var from = Pagination.calcOffset(size, current);

          if (onChange) {
            onChange(e, {
              name: name,
              value: from
            });
            if (onNext) onNext();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleToLast", function (e) {
      var _this$props9 = _this.props,
          name = _this$props9.name,
          disabled = _this$props9.disabled;
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var _this$state = _this.state,
          current = _this$state.current,
          totalPages = _this$state.totalPages;
      var currentIndex = current - 1; // index length = total pages

      if (currentIndex < totalPages - 1) {
        _this.setState({
          current: totalPages
        }, function () {
          var _this$props10 = _this.props,
              onChange = _this$props10.onChange,
              onNext = _this$props10.onNext,
              size = _this$props10.size;
          var from = Pagination.calcOffset(size, totalPages);

          if (onChange) {
            onChange(e, {
              name: name,
              value: from
            });
            if (onNext) onNext();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputOnChange", function (e, _ref2) {
      var value = _ref2.value;
      var disabled = _this.props.disabled;
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      _this.setState({
        targetPage: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleConfirmNavigate", function (e) {
      var _this$props11 = _this.props,
          name = _this$props11.name,
          disabled = _this$props11.disabled;
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var _this$state2 = _this.state,
          current = _this$state2.current,
          targetPage = _this$state2.targetPage,
          totalPages = _this$state2.totalPages;

      if (current !== targetPage && targetPage >= 1 && targetPage <= totalPages) {
        _this.setState({
          current: targetPage,
          targetPage: null
        }, function () {
          var _this$props12 = _this.props,
              onChange = _this$props12.onChange,
              size = _this$props12.size;
          var from = Pagination.calcOffset(size, targetPage);

          if (onChange) {
            onChange(e, {
              name: name,
              value: from
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderPagination", function () {
      var _this$state3 = _this.state,
          current = _this$state3.current,
          centerRange = _this$state3.centerRange,
          totalPages = _this$state3.totalPages;
      var currentIndex = current - 1;
      var arr = [];

      var _loop = function _loop(i) {
        var number = i + 1;
        arr.push(_react.default.createElement(_List.default.Item, {
          key: number
        }, _react.default.createElement(_Button.default, {
          basic: true,
          color: i === currentIndex ? 'blue' : null,
          onClick: function onClick(e) {
            return _this.handleOnPageClick(e, number);
          }
        }, "".concat(number))));
      };

      for (var i = 0; i < totalPages; i += 1) {
        _loop(i);
      }

      var filteredArr;
      var halfRange = (centerRange - 1) / 2;

      if (currentIndex >= centerRange && currentIndex <= arr.length - centerRange) {
        // filter 5
        filteredArr = [].concat(arr).filter(function (number, index) {
          return index >= currentIndex - halfRange && index <= currentIndex + halfRange;
        });
      }

      if (currentIndex < centerRange) {
        // show front part-
        filteredArr = [].concat(arr).filter(function (number, index) {
          return index <= centerRange;
        });
      }

      if (currentIndex >= arr.length - centerRange) {
        // show end part
        filteredArr = [].concat(arr).filter(function (number, index) {
          return index >= arr.length - (centerRange + 1);
        });
      }

      return _react.default.createElement(_react.Fragment, null, currentIndex >= centerRange ? _react.default.createElement(_react.Fragment, null, arr[0], _react.default.createElement(_List.default.Item, {
        className: "ellipsis"
      }, "\xB7\xB7\xB7")) : null, filteredArr, currentIndex <= arr.length - (centerRange + 1) ? _react.default.createElement(_react.Fragment, null, _react.default.createElement(_List.default.Item, {
        className: "ellipsis"
      }, "\xB7\xB7\xB7"), arr[arr.length - 1]) : null);
    });

    var _from = props.from,
        _size = props.size,
        total = props.total;

    var _current = _from / _size + 1;

    if (_current < 0) {
      _current = 0;
    }

    var _totalPages = Pagination.calcTotalPages(total, _size);

    if (_current >= _totalPages) {
      _current = _totalPages;
    }

    _this.state = {
      prevPropsFrom: _from,
      prevPropsSize: _size,
      prevPropsTotal: total,
      current: _current,
      centerRange: _this.getCenterRange(),
      targetPage: null,
      totalPages: _totalPages
    };
    _this.inputRef = (0, _react.createRef)();
    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props13 = this.props,
          as = _this$props13.as,
          name = _this$props13.name,
          total = _this$props13.total,
          fluid = _this$props13.fluid,
          hideOnSinglePage = _this$props13.hideOnSinglePage,
          size = _this$props13.size,
          disabled = _this$props13.disabled,
          onNext = _this$props13.onNext,
          onChange = _this$props13.onChange,
          onBack = _this$props13.onBack,
          centerRange = _this$props13.centerRange,
          rest = _objectWithoutProperties(_this$props13, ["as", "name", "total", "fluid", "hideOnSinglePage", "size", "disabled", "onNext", "onChange", "onBack", "centerRange"]);

      var _this$state4 = this.state,
          targetPage = _this$state4.targetPage,
          totalPages = _this$state4.totalPages;
      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames(); // hide on single page;

      if (totalPages <= 1 && hideOnSinglePage) return null;
      return _react.default.createElement(_MediaSize.default, {
        onChange: this.handleMediaSizeOnChange
      }, function (_ref3) {
        var isMobile = _ref3.isMobile;
        return _react.default.createElement(Wrapper, _extends({}, rest, {
          className: classNames,
          middle: as === _Row.default
        }), _react.default.createElement(_Column.default, {
          as: _Row.default,
          center: {
            sm: true,
            xs: true
          }
        }, _react.default.createElement(_List.default, {
          className: "list-wrapper",
          horizontal: true
        }, isMobile ? _react.default.createElement(_List.default.Item, null, _react.default.createElement(_Button.default, {
          className: "back-button",
          basic: true,
          icon: _react.default.createElement(_Icon.default, {
            name: _Icon.default.FirstPage
          }),
          onClick: _this2.handleToFirst
        })) : null, _react.default.createElement(_List.default.Item, null, _react.default.createElement(_Button.default, {
          className: "back-button",
          basic: true,
          icon: _react.default.createElement(_Icon.default, {
            name: _Icon.default.ChevronLeft
          }),
          onClick: _this2.handleOnBack
        })), _this2.renderPagination(), _react.default.createElement(_List.default.Item, null, _react.default.createElement(_Button.default, {
          className: "next-button",
          basic: true,
          icon: _react.default.createElement(_Icon.default, {
            name: _Icon.default.ChevronRight
          }),
          onClick: _this2.handleOnNext
        })), isMobile ? _react.default.createElement(_List.default.Item, null, _react.default.createElement(_Button.default, {
          className: "next-button",
          basic: true,
          icon: _react.default.createElement(_Icon.default, {
            name: _Icon.default.LastPage
          }),
          onClick: _this2.handleToLast
        })) : null)), _react.default.createElement(_Column.default, {
          className: "input-main-wrapper"
        }, _react.default.createElement(_Label.default, {
          content: "Go to",
          rightNode: _react.default.createElement("div", {
            className: "input-wrapper"
          }, _react.default.createElement(_Input.default, {
            type: "number",
            innerRef: _this2.inputRef,
            onChange: _this2.handleInputOnChange,
            value: targetPage,
            min: 1,
            max: totalPages,
            onFocus: _this2.handleAddInputListener,
            onBlur: _this2.handleRemoveInputListener
          }), _react.default.createElement(_Button.default, {
            basic: true,
            icon: _react.default.createElement(_Icon.default, {
              name: _Icon.default.Go
            }),
            onClick: _this2.handleConfirmNavigate
          })),
          headerNode: function headerNode(_ref4) {
            var className = _ref4.className,
                content = _ref4.content,
                rightNode = _ref4.rightNode,
                headerRest = _objectWithoutProperties(_ref4, ["className", "content", "rightNode"]);

            return _react.default.createElement(_Row.default, {
              className: className,
              start: true,
              center: {
                sm: true,
                xs: true
              }
            }, _react.default.createElement(_Header.default, _extends({}, headerRest, {
              capitalize: true
            }), content), rightNode);
          }
        })));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var from = props.from,
          size = props.size,
          total = props.total;

      if (from !== state.prevPropsFrom || size !== state.prevPropsSize || total !== state.prevPropsTotal) {
        var current = from / size + 1;

        if (current < 0) {
          current = 0;
        }

        var totalPages = Pagination.calcTotalPages(total, size);

        if (current >= totalPages) {
          current = totalPages;
        }

        return {
          prevPropsFrom: from,
          prevPropsSize: size,
          prevPropsTotal: total,
          current: current,
          totalPages: totalPages
        };
      }

      return null;
    }
  }]);

  return Pagination;
}(_react.PureComponent);

exports.default = Pagination;

_defineProperty(Pagination, "className", 'MHub-Pagination');

_defineProperty(Pagination, "defaultCenterRange", 5);

_defineProperty(Pagination, "propTypes", {
  as: _common.customPropTypes.as,
  name: _propTypes.default.string,
  from: _propTypes.default.number,
  total: _propTypes.default.number.isRequired,
  size: _propTypes.default.number.isRequired,
  onChange: _propTypes.default.func,
  onBack: _propTypes.default.func,
  onNext: _propTypes.default.func,
  fluid: _propTypes.default.bool,
  centerRange: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  hideOnSinglePage: _propTypes.default.bool
});

_defineProperty(Pagination, "defaultProps", {
  as: _Row.default,
  name: null,
  onChange: null,
  onBack: null,
  onNext: null,
  fluid: false,
  centerRange: Pagination.defaultCenterRange,
  disabled: false,
  hideOnSinglePage: false,
  from: 0
});

_defineProperty(Pagination, "calcOffset", function (size, current) {
  var index = current - 1;
  return index * size;
});

_defineProperty(Pagination, "calcTotalPages", function (total, size) {
  if (total && size) return Math.ceil(total / size);
  return 0;
});